import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PortfolioDetails } from "../../../../../../model/finzy-flex/portfolio.model";
import { ProductListForCreatePortfolio } from "../../../../../../model/finzy-flex/product-list.model";
import { FfEndPoints } from "../../../ff-endpoints";

@Component({
    selector: 'app-portfolio-creation-successful',
    templateUrl: './portfolio-creation-successful.component.html',
    styleUrls: ['./portfolio-creation-successful.component.scss']
})
export class PortfolioCreationSuccessfulComponent implements OnInit {
    private readonly router: Router;
    private readonly activatedRoute: ActivatedRoute;
    public productList: ProductListForCreatePortfolio[] = [];
    public productDetails: PortfolioDetails;
    state$: Observable<any>;
    constructor(
        router: Router,
        activatedRoute: ActivatedRoute,
    ) {
        this.router = router;
        this.activatedRoute = activatedRoute;
    }
    async ngOnInit() {
        try {
            this.state$ = this.activatedRoute.paramMap
                .pipe(map(() => window.history.state));
                this.state$.subscribe((navData) => {
                    this.productDetails =  navData?.response;
                });
            await this.productDetails.data.forEach((products) => {
                const productsWithNameAsAttribute = products.productAttributes.find((attribute) => attribute.code == 'NAME');
                if (productsWithNameAsAttribute) {
                    const product: ProductListForCreatePortfolio = {
                        consents: products.consents,
                        investmentAmount: products.investmentAmount,
                        productName: productsWithNameAsAttribute.value.toString(),
                    }
                    this.productList.push(product);
                }
            });
            if (this.productList.length <= 0) {
                this.router.navigate([FfEndPoints.FINZY_FLEX]);
            }
        } catch (error) {
            this.router.navigate([FfEndPoints.FINZY_FLEX]);
        }
        
    }

    public onClickTrackYourInvestment() {
        this.router.navigate([FfEndPoints.FINZY_FLEX]);
    }
}